/* VP Smart Search Parser, gemeinsam genutzt von assets/vp-smart-search.js (im Browser) und Tests (Node) */
(function (root) {
  function norm(s) {
    return String(s || '').toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/o(e)?ko\s*-?\s*tex/g, 'oekotex')
      .replace(/made\s*in\s*(der\s*)?(eu|europa|europe)/g, 'madeineu')
      .replace(/made\s*in\s*(germany|deutschland)/g, 'madeingermany')
      .replace(/coffee\s*to\s*go|to\s*go\s*becher|(kaffee|tee)?becher\s+(zum\s+)?(to\s*go|mitnehmen)/g, 'togobecher')
      .replace(/welcome\s*kits?|welcome\s*box(en)?|onboarding\s*(kits?|box(en)?|pakete?)/g, 'onboarding')
      .replace(/give\s*aways?|giveaways?/g, 'giveaway')
      .replace(/t\s*-?\s*shirts?/g, 'tshirt')
      .replace(/[^a-z0-9€.,\s]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  var COLORS = [
    { g: 'Schwarz', hex: '#1b1b1b', q: ['schwarz', 'black'], m: ['schwarz', 'black', 'jet', 'tiefschwarz'] },
    { g: 'Weiß', hex: '#ffffff', q: ['weiss', 'weis', 'white'], m: ['weiss', 'white', 'ecru', 'offwhite'] },
    { g: 'Grau', hex: '#8a8f98', q: ['grau', 'grey', 'gray', 'anthrazit', 'dunkelgrau', 'hellgrau'], m: ['grau', 'grey', 'gray', 'anthrazit', 'anthracite', 'graphit', 'graphite', 'charcoal', 'slate'] },
    { g: 'Silber und Metall', hex: '#b8bcc4', q: ['silber', 'silbern', 'silver', 'gold', 'golden', 'kupfer', 'metallic', 'chrom'], m: ['silber', 'silver', 'chrom', 'chrome', 'titan', 'gunmetal', 'metallic', 'kupfer', 'copper', 'gold', 'bronze'] },
    { g: 'Blau', hex: '#1f4fa3', q: ['blau', 'blue', 'navy', 'marine', 'marineblau', 'dunkelblau', 'hellblau', 'turkis', 'petrol', 'royalblau', 'konigsblau'], m: ['blau', 'blue', 'navy', 'marine', 'petrol', 'turkis', 'turquoise', 'teal', 'aqua', 'kobalt', 'cobalt', 'royal', 'denim', 'ocean', 'sky'] },
    { g: 'Grün', hex: '#3f8a4f', q: ['grun', 'green', 'olive', 'oliv', 'mint', 'khaki', 'dunkelgrun', 'hellgrun', 'tannengrun', 'waldgrun', 'salbei'], m: ['grun', 'green', 'olive', 'oliv', 'khaki', 'mint', 'lime', 'limette', 'moos', 'salbei', 'sage', 'pistazie', 'forest', 'kelly'] },
    { g: 'Rot', hex: '#c8262b', q: ['rot', 'red', 'bordeaux', 'dunkelrot', 'weinrot', 'kirschrot'], m: ['rot', 'red', 'bordeaux', 'burgund', 'burgundy', 'cherry', 'rubin', 'ruby', 'maroon', 'himbeer', 'raspberry', 'kirsch'] },
    { g: 'Orange', hex: '#f26b21', q: ['orange', 'orangen', 'koralle', 'apricot', 'terracotta'], m: ['orange', 'apricot', 'koralle', 'coral', 'terracotta', 'rost', 'rust', 'peach', 'pfirsich'] },
    { g: 'Gelb', hex: '#f2c94c', q: ['gelb', 'yellow', 'senf', 'senfgelb'], m: ['gelb', 'yellow', 'senf', 'mustard', 'zitrone', 'lemon', 'ocker'] },
    { g: 'Rosa und Pink', hex: '#e8669c', q: ['rosa', 'pink', 'rose', 'magenta', 'fuchsia', 'altrosa'], m: ['rosa', 'pink', 'magenta', 'fuchsia', 'blush', 'lachs', 'salmon'] },
    { g: 'Lila', hex: '#7a4fb5', q: ['lila', 'violett', 'purple', 'lavendel', 'flieder'], m: ['lila', 'purple', 'violett', 'violet', 'lavendel', 'lavender', 'flieder', 'aubergine', 'pflaume', 'plum', 'mauve'] },
    { g: 'Braun', hex: '#7b4b2a', q: ['braun', 'brown', 'cognac', 'camel'], m: ['braun', 'brown', 'schokolade', 'chocolate', 'mokka', 'cognac', 'camel', 'tabak'] },
    { g: 'Beige und Natur', hex: '#dccbb1', q: ['beige', 'natur', 'naturfarben', 'sand', 'creme', 'cremefarben', 'taupe'], m: ['beige', 'natur', 'natural', 'sand', 'creme', 'cream', 'taupe', 'ungefarbt', 'undyed', 'elfenbein', 'ivory', 'stone', 'kraft'] },
    { g: 'Holz', hex: '#c39a6b', q: ['holzfarben'], m: ['holz', 'wood', 'bambus', 'bamboo', 'buche', 'beech', 'eiche', 'oak', 'walnuss', 'walnut', 'kork', 'cork'] },
    { g: 'Transparent', hex: '', q: ['transparent', 'durchsichtig'], m: ['transparent', 'clear', 'frosted', 'milchig'] },
    { g: 'Mehrfarbig', hex: '', q: ['bunt', 'mehrfarbig', 'farbig', 'regenbogen'], m: ['mehrfarbig', 'multicolor', 'multi', 'bunt', 'assorted', 'sortiert', 'gemischt', 'mixed', 'regenbogen', 'rainbow'] }
  ];
  COLORS.forEach(function (c) {
    c.re = new RegExp('^(' + c.q.join('|') + ')(e|er|es|en|em|n)?$');
    c.mre = c.m.map(function (w) {
      return w.length <= 3 ? new RegExp('(^|[^a-z]|dunkel|hell|tief|wein|kirsch|signal|feuer|neon|pastell)' + w + '([^a-z]|$|e|er|es)') : null;
    });
  });

  // 13.10.2026 abends: Anlässe nur noch als ganze Wörter. Vorher fing weihnacht\w* auch „Weihnachtskugel“ und messe\w* auch „Messer“ ab
  var OCCASIONS = [
    { re: /^(adventskalender\w*|advent|adventszeit)$/, label: 'Adventskalender', h: 'adventskalender', prices: [[5, 'adventskalender-unter-5'], [10, 'adventskalender-unter-10']] },
    { re: /^(weihnacht|weihnachten|weihnachtlich\w*|weihnachtsgeschenk\w*|weihnachtsfeier\w*|xmas|christmas|nikolaus)$/, label: 'Weihnachten', h: 'weihnachten', prices: [[10, 'werbeartikel-weihnachten-unter-10']], page: '/pages/weihnachtsgeschenke-mitarbeiter' },
    { re: /^(ostern|osterfest|ostergeschenk\w*)$/, label: 'Ostern', h: 'ostern' },
    { re: /^(sommerfest|sommerfeste)$/, label: 'Sommerfeste', h: 'sommerfeste' },
    { re: /^(sommer|sommerlich\w*|strand)$/, label: 'Strand und Sommer', h: 'strandartikel' }, // „Strandtuch“, „Strandtasche“ erkennt das Wörterbuch
    { re: /^(herbst|herbstlich\w*)$/, label: 'Herbst', h: 'herbst' },
    { re: /^(winter|winterlich\w*)$/, label: 'Winter', h: 'winter' },
    { re: /^(messe|messen|messestand|messegeschenk\w*|konferenz|konferenzen|kongress|tagung|tagungen|event|events)$/, label: 'Messen und Konferenzen', h: 'messen-konferenzen' },
    { re: /^(festival|festivals)$/, label: 'Festivals', h: 'festivals' },
    { re: /^(onboarding|welcome|willkommen\w*|einstand)$/, label: 'Onboarding', h: 'geschenkbox', page: '/pages/mitarbeiter-geschenkboxen' },
    { re: /^(express|eilig\w*|kurzfristig\w*|schnell\w*|sofort)$/, label: 'Express', h: 'expressprodukte' }
  ];

  var AUDIENCE = /^(mitarbeiter\w*|kunden\w*|kundengeschenk\w*|team|teams|belegschaft|kollegen|kolleginnen|azubi\w*|partner)$/;
  var GIFT = /^(geschenk|geschenke|geschenkidee\w*|present|presente|prasent|giveaway|werbegeschenk\w*|mitbringsel)$/; // 13.10.2026: nicht mehr geschenk\w* (Geschenkbeutel, Geschenkbox sind Produktwörter)

  var CERTS = [
    { re: /^(fsc)$/, z: ['fsc'], label: 'FSC' },
    { re: /^(pefc)$/, z: ['pefc'], label: 'PEFC' },
    { re: /^(grs)$/, z: ['grs'], label: 'GRS' },
    { re: /^(rcs)$/, z: ['rcs'], label: 'RCS' },
    { re: /^(ocs)$/, z: ['ocs'], label: 'OCS' },
    { re: /^(gots)$/, z: ['gots'], label: 'GOTS' },
    { re: /^(oekotex)$/, z: ['oekotex', 'oeko-tex'], m: ['oeko-tex-100', 'oekotex'], label: 'OEKO TEX' },
    { re: /^(fairtrade|fair)$/, z: ['fairtrade', 'fair-trade'], label: 'Fairtrade' },
    { re: /^(aware)$/, z: ['aware'], label: 'AWARE' },
    { re: /^(biobaumwolle|organic)$/, z: ['gots', 'ocs'], m: ['biobaumwolle'], label: 'Biobaumwolle', term: 'baumwolle' },
    { re: /^(bio)$/, z: ['bio', 'eu-bio', 'gots', 'ocs'], m: ['biobaumwolle', 'bio'], label: 'Bio zertifiziert' },
    { re: /^(recycel\w*|recycl\w*|upcycl\w*)$/, m: ['recycelt', 'recycled'], label: 'Recyceltes Material' },
    { re: /^(madeineu)$/, m: ['made-in-eu', 'made-in-germany'], label: 'Made in EU' },
    { re: /^(madeingermany)$/, m: ['made-in-germany'], label: 'Made in Germany' },
    { re: /^(vegan\w*)$/, m: ['vegan'], label: 'Vegan laut Hersteller' }
  ];

  var CATS = [
    ['taschenlampe|stirnlampe|lampe|leuchte', 'leuchten', 'Taschenlampen und Leuchten'],
    ['laptoptasche|laptophulle|sleeve|aktentasche', 'akten-laptoptaschen', 'Laptoptaschen und Sleeves'],
    ['kuhltasche|kuhlbox', 'kuhltaschen', 'Kühltaschen'],
    ['kosmetiktasche|kulturbeutel|kulturtasche|waschtasche', 'kosmetikbeutel', 'Kulturbeutel und Kosmetiktaschen'],
    ['sporttasche|reisetasche|weekender|duffel', 'sport-reisetaschen', 'Sport und Reisetaschen'],
    ['umhangetasche|gurteltasche|bauchtasche|crossbody', 'schultertaschen', 'Umhängetaschen und Gürteltaschen'],
    ['snackbeutel|lunchbag|snacktute', 'snacktuten', 'Lunchbags und Snackbeutel'],
    ['einkaufstasche|shopper|jutetasche|baumwolltasche|stofftasche|tragetasche|stoffbeutel', 'shopper-tragetaschen', 'Shopper und Tragetaschen'],
    ['gemusebeutel|obstbeutel|netzbeutel|obstnetz|gemusenetz', 'obst-gemuese-netzbeutel', 'Obst-, Gemüse- und Netzbeutel'],
    ['kordelzugbeutel|kordelbeutel|zugbeutel|jutebeutel|turnbeutel|sportbeutel|gymbag|beutel', 'kordelzugbeutel', 'Kordelzugbeutel und Turnbeutel'],
    ['warnweste|sicherheitsweste|reflektor|reflektorband|reflektoren|schnapparmband|slapband', 'reflektoren-sicherheit', 'Reflektoren und Warnwesten'],
    ['rucksack|rucksacke|backpack', 'rucksacke', 'Rucksäcke'],
    ['thermosflasche|isolierflasche|thermoskanne|vakuumflasche|thermos', 'thermosflaschen', 'Thermosflaschen und Isolierflaschen'],
    ['flasche|bottle', 'trinkflaschen', 'Trinkflaschen'],
    ['thermobecher|togobecher|kaffeebecher|reisebecher', 'thermobecher', 'Thermobecher'],
    ['tasse|becher|mug', 'tassen', 'Becher und Tassen'],
    ['glas|glaser|karaffe', 'glaser', 'Gläser und Karaffen'],
    ['lunchbox|brotdose|brotbox|bentobox|essensbox|vorratsdose|dose', 'lunchboxen-brotdosen', 'Lunchboxen und Brotdosen'],
    ['hoodie|kapuzen|pullover|pulli|sweatshirt|sweater', 'hoodies', 'Hoodies und Sweatshirts'],
    ['tshirt|shirt|polo', 't-shirts', 'T Shirts und Polos'],
    ['jacke|weste|fleece|softshell', 'jacken', 'Jacken und Westen'],
    ['socke|socken', 'socken', 'Socken'],
    ['mutze|beanie|cap|kappe|schal|basecap', 'caps', 'Caps, Mützen und Schals'],
    ['regenponcho|poncho', 'regenponchos', 'Regenponchos'],
    ['regenschirm|schirm', 'regenschirme', 'Regenschirme'],
    ['notizblock|haftnotiz|postit|sticky', 'notizblocke', 'Notizblöcke und Haftnotizen'],
    ['notizbuch|notizbucher|notebook|notizheft|journal', 'notizbucher', 'Notizbücher'],
    ['kugelschreiber|kuli|stift|pen|marker', 'schreibgerate', 'Kugelschreiber und Stifte'],
    ['powerbank', 'powerbanks', 'Powerbanks'],
    ['ladekabel|ladegerat|kabel|charger', 'ladegerate', 'Ladegeräte und Kabel'],
    ['kopfhorer|lautsprecher|speaker|earbuds|headphone', 'kopfhorer', 'Kopfhörer und Lautsprecher'],
    ['schlusselanhanger|anhanger|keychain', 'schlusselanhanger', 'Schlüsselanhänger'],
    ['lanyard|umhangeband|schlusselband', 'lanyards', 'Lanyards und Festivalbänder'],
    ['bademantel', 'wellnesstextilien', 'Bademäntel und Handtücher'],
    ['handtuch|decke|plaid|badetuch', 'wohntextilien', 'Handtücher und Decken'],
    ['kerze|raumduft', 'duftkerzen', 'Kerzen und Raumduft'],
    ['schokolade|praline|schoko', 'schokolade', 'Schokolade und Pralinen'],
    ['fruchtgummi|gummibar|bonbon|lutscher', 'fruchtgummi', 'Fruchtgummi und Bonbons'],
    ['pfefferminz|kaugummi|mints', 'pfefferminz', 'Pfefferminz und Kaugummi'],
    ['nuss|nusse|nusssnack', 'nusse', 'Nüsse und Snacks'],
    ['sussigkeit|susses|nasch|snack', 'sussigkeiten', 'Süßigkeiten'],
    ['tee|kaffee', 'tee', 'Tee und Kaffee'],
    ['geschenkbox|giftbox|prasentbox|weihnachtsbox', 'geschenkbox', 'Geschenkboxen'],
    ['sonnenbrille', 'sonnenbrillen', 'Sonnenbrillen'],
    ['wachstuch|bienenwachstuch', 'wachstucher', 'Wachstücher'],
    ['spiel|puzzle|kartenspiel', 'spiele', 'Spiele'],
    ['werkzeug|multitool|taschenmesser|zollstock', 'werkzeug', 'Werkzeug, Auto und Fahrrad'],
    ['tracker|airtag', 'tracker', 'Tracker und Wearables'],
    ['tasche|bag', 'taschen-rucksacken', 'Taschen und Rucksäcke']
  ].map(function (r) { return { alts: r[0].split('|'), h: r[1], label: r[2] }; });

  var STOP = ('ich wir du ihr sie suche suchen such brauche brauchen benotige benotigen hatte hatten gern gerne bitte mochte mochten will wollen ' +
    'fur fuer mit und oder von vom zu zum zur in im am an auf aus als der die das den dem des ein eine einen einem einer etwas was welche welcher welches ' +
    'gibt es habt hast artikel werbeartikel werbemittel produkt produkte sachen dinge idee ideen logo logos bedruckt bedrucken bedruckte bedruckten ' +
    'bedruckter individuell individuelle eigenem eigenen eigenes eigene eigener design firmenlogo firma unternehmen merch merchandise kit kits set sets ' +
    'neue neuen neuer neu schon schone schoner schones coole cool cooler coolen tolle toll toller hochwertig hochwertige hochwertigen hochwertiger ' +
    'nachhaltig nachhaltige nachhaltigen nachhaltiger umweltfreundlich umweltfreundliche okologisch oko green eco stuck stk st paar mal ca circa ' +
    'passend passende passendes alle allen irgendwas so wie z b zb to go').split(' ');

  var PRICE_RE = /(?:unter|bis zu|bis|max\.?|maximal|hochstens|weniger als|<)\s*(\d+(?:[.,]\d+)?)\s*(?:€|euro|eur)?|(\d+(?:[.,]\d+)?)\s*(?:€|euro|eur)\b/;
  var QTY_RE = /\b\d+\s*(?:stuck|stk|st|exemplare|pcs|mal)\b/g;
  var CHEAP_RE = /^(gunstig\w*|billig\w*|preiswert\w*|gunstigste\w*)$/;

  function matchAlt(tok, alt) {
    if (alt.length <= 4) return tok === alt || tok === alt + 's' || tok === alt + 'n' || tok === alt + 'e' || tok === alt + 'en' || tok === alt + 'er';
    return tok === alt || (tok.length - alt.length >= 3 && /^(|e|n|en|s|er|es)$/.test(tok.slice(tok.lastIndexOf(alt) + alt.length)) && tok.lastIndexOf(alt) >= 3); // 13.10.2026: nur Wortende (Kompositum), nie mitten im Wort („müslischale“ ≠ „schal“)
  }

  /* Wörterbuch aus dem Sortiment (assets/vp-suche-woerter.js, erzeugt von sortiment-v2/suchwoerter.mjs, 13.10.2026): Wort → Produktart-Seite/Kachel bzw. Marke.
     Treffer: ganzes Wort (auch mit Endung -e/-n/-en/-s/-er/-es) oder Kopf eines zusammengesetzten Worts (längster bekannter Wortteil am Ende, Rest mindestens 3 Buchstaben). */
  var ENDUNG = ['nen', 'en', 'er', 'es', 'n', 'e', 's'];
  function formen(t) { var f = [t]; ENDUNG.forEach(function (e) { if (t.length - e.length >= 3 && t.slice(-e.length) === e) f.push(t.slice(0, -e.length)); }); return f; }
  function zielVon(W, v) { var z = W.ziele[v < 0 ? -1 - v : v]; return z ? { h: z[0], label: z[1] } : null; }
  function lookup(t, erstes) {
    var W = root.VpSucheWoerter;
    if (!W) { var cat = CATS.find(function (ct) { return ct.alts.some(function (a) { return matchAlt(t, a); }); }); return cat ? { h: cat.h, label: cat.label, token: t, exact: cat.alts.indexOf(t) > -1 } : null; }
    if (W.m[t] != null && (W.m[t] >= 0 || erstes)) { var b = zielVon(W, W.m[t]); return b && { h: b.h, label: b.label, token: t, exact: true, brand: true }; }
    var f = formen(t), i, j;
    for (i = 0; i < f.length; i++) if (W.w[f[i]] != null) { var z = zielVon(W, W.w[f[i]]); return z && { h: z.h, label: z.label, token: t, exact: true, oberbegriff: W.w[f[i]] < 0 }; }
    for (i = 3; i <= t.length - 4; i++) { var rest = formen(t.slice(i)); for (j = 0; j < rest.length; j++) if (rest[j].length >= 4 && W.w[rest[j]] != null) { var k = zielVon(W, W.w[rest[j]]); return k && { h: k.h, label: k.label, token: t, exact: false, kopf: rest[j] }; } }
    return null;
  }
  var PREP = /^(mit|aus|fur|fuer|in|im|von|ohne|zum|zur|als)$/;
  var SKU_RE = /^\s*(vp)?[\s-]?(\d{4,9})\s*$/i;

  function stem(raw) {
    var w = raw;
    if (w.length > 5 && /en$/i.test(w)) return w.slice(0, -1);
    if (w.length > 4 && /[^s]s$/i.test(w)) return w.slice(0, -1);
    return w;
  }

  function parse(input) {
    var original = String(input || '').trim();
    var n = norm(original);
    var out = { original: original, colors: [], occasion: null, audience: false, gift: false, price: null, cheap: false, certs: [], category: null, brand: null, sku: null, terms: [], rawTerms: [] };
    var sm = original.match(SKU_RE);
    if (sm && (sm[1] || sm[2].length >= 5)) { out.sku = { n: sm[2], formen: ['VP-' + sm[2], 'VP' + sm[2]] }; out.searchQ = original; return out; } // Artikelnummer (VP-90476, VP1000105, 90476)
    var nachPrep = false;

    var pm = n.match(PRICE_RE);
    if (pm) {
      out.price = parseFloat((pm[1] || pm[2]).replace(',', '.'));
      n = n.replace(pm[0], ' ');
    }
    n = n.replace(QTY_RE, ' ');

    var rawTokens = original.replace(/[^\p{L}\p{N}\s]/gu, ' ').split(/\s+/).filter(Boolean);
    var rawMap = {};
    rawTokens.forEach(function (r) { rawMap[norm(r).replace(/\s/g, '')] = r; });
    rawMap.tshirt = 'Shirt'; rawMap.togobecher = 'to go Becher';

    var toks = n.split(' ').filter(Boolean);
    var W = root.VpSucheWoerter;
    if (W) {
      if (!W._mehr) W._mehr = Object.keys(W.m).filter(function (k) { return k.indexOf(' ') > 0; }).sort(function (a, b) { return b.length - a.length; });
      var nn = ' ' + toks.join(' ') + ' ';
      for (var mi = 0; mi < W._mehr.length && !out.brand; mi++) if (nn.indexOf(' ' + W._mehr[mi] + ' ') > -1) { var mz = zielVon(W, W.m[W._mehr[mi]]); if (mz) { out.brand = { h: mz.h, label: mz.label, token: W._mehr[mi], exact: true, brand: true }; nn = nn.replace(' ' + W._mehr[mi] + ' ', ' '); } }
      toks = nn.trim().split(' ').filter(Boolean);
      for (var ti = 0; ti < toks.length - 1; ti++) if (W.w[toks[ti] + toks[ti + 1]] != null) { rawMap[toks[ti] + toks[ti + 1]] = (rawMap[toks[ti]] || toks[ti]) + ' ' + (rawMap[toks[ti + 1]] || toks[ti + 1]); toks.splice(ti, 2, toks[ti] + toks[ti + 1]); } // „usb stick“ → usbstick
      if (out.brand) { out.terms.push(out.brand.token); out.rawTerms.push(out.brand.label); }
    }
    var erstes = true;
    toks.forEach(function (t) {
      var istErstes = erstes; erstes = false;
      if (/^\d+([.,]\d+)?$/.test(t) || t === '€' || t === 'euro' || t === 'eur') return;
      var c = COLORS.find(function (col) { return col.re.test(t); });
      if (c) { if (out.colors.indexOf(c) < 0) out.colors.push(c); return; }
      var o = OCCASIONS.find(function (oc) { return oc.re.test(t); });
      if (o) {
        if (!out.occasion) out.occasion = o;
        if (o.h === 'adventskalender' && !out.category) return;
        return;
      }
      if (AUDIENCE.test(t)) { out.audience = true; return; }
      if (GIFT.test(t)) { out.gift = true; return; }
      if (CHEAP_RE.test(t)) { out.cheap = true; return; }
      var ce = CERTS.find(function (cc) { return cc.re.test(t); });
      if (ce) {
        if (out.certs.indexOf(ce) < 0) out.certs.push(ce);
        if (ce.term) { out.terms.push(ce.term); out.rawTerms.push(ce.term); }
        return;
      }
      if (PREP.test(t)) { nachPrep = true; return; }
      if (STOP.indexOf(t) > -1 || t.length < 2) return;
      var hit = lookup(t, istErstes);
      if (hit && hit.brand) { if (!out.brand) out.brand = hit; }
      else if (hit && (!out.category || (!nachPrep && !formen(t).some(function (f) { return out.category.token !== t && out.category.token.slice(-f.length) === f; })))) out.category = hit; // „to go Becher“: das allgemeinere „Becher“ ersetzt das genauere Wort nicht // Hauptwort steht vor „mit/aus/für“: „Brotdose aus Edelstahl“ → Brotdose
      out.terms.push(t);
      out.rawTerms.push(rawMap[t] || t);
    });

    if (out.rawTerms.length) out.rawTerms[out.rawTerms.length - 1] = stem(out.rawTerms[out.rawTerms.length - 1]);
    out.searchQ = out.rawTerms.join(' ');
    return out;
  }

  function colorOfText(text, color) {
    var t = norm(text);
    if (!t) return false;
    for (var i = 0; i < color.m.length; i++) {
      var re = color.mre[i];
      if (re ? re.test(t) : t.indexOf(color.m[i]) > -1) return true;
    }
    return false;
  }

  var api = { parse: parse, norm: norm, colorOfText: colorOfText, lookup: lookup, formen: formen, COLORS: COLORS, OCCASIONS: OCCASIONS, CATS: CATS };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.VpSmartParser = api;
})(typeof window !== 'undefined' ? window : this);
/* VP Smarte Suche, Oberfläche (27.09.2026, Mehr anzeigen, einmaliger Farbwisch, Filterfarbe vpk.f_farbe hat Vorrang vor dem Variantennamen; unter 1024 px öffnet das Suchsymbol des Themes diese Suche als Vollbild). Parser siehe oben (VpSmartParser). */
(function () {
  if (!window.customElements || window.customElements.get('vp-header-search')) return;
  var P = window.VpSmartParser;

  var OPTION_VALUES = {
    'Schwarz': ['Schwarz', 'schwarz', 'Black', 'Jet Black'],
    'Weiß': ['Weiß', 'weiß', 'Weiss', 'White', 'Off White'],
    'Grau': ['Grau', 'grau', 'Anthrazit', 'Dunkelgrau', 'Hellgrau', 'Grey', 'Gray'],
    'Silber und Metall': ['Silber', 'silber', 'Silver', 'Gold', 'Kupfer'],
    'Blau': ['Blau', 'blau', 'Navy', 'Dunkelblau', 'Hellblau', 'Royalblau', 'Marine', 'Blue', 'Türkis', 'Petrol'],
    'Grün': ['Grün', 'grün', 'Dunkelgrün', 'Hellgrün', 'Olive', 'Mint', 'Khaki', 'Green', 'Tannengrün', 'Waldgrün'],
    'Rot': ['Rot', 'rot', 'Dunkelrot', 'Bordeaux', 'Weinrot', 'Red', 'Burgund'],
    'Orange': ['Orange', 'orange', 'Koralle', 'Apricot'],
    'Gelb': ['Gelb', 'gelb', 'Yellow', 'Senfgelb'],
    'Rosa und Pink': ['Rosa', 'Pink', 'rosa', 'pink', 'Magenta', 'Altrosa'],
    'Lila': ['Lila', 'lila', 'Violett', 'Purple', 'Lavendel', 'Flieder'],
    'Braun': ['Braun', 'braun', 'Brown', 'Cognac', 'Camel'],
    'Beige und Natur': ['Beige', 'beige', 'Natur', 'natur', 'Sand', 'Creme', 'Taupe', 'Natural'],
    'Holz': ['Holz', 'Bambus'],
    'Transparent': ['Transparent', 'transparent', 'Klar'],
    'Mehrfarbig': ['Mehrfarbig', 'Bunt', 'Multicolor']
  };
  var COLOR_WORD = { 'Silber und Metall': 'silber', 'Rosa und Pink': 'rosa', 'Beige und Natur': 'beige' };
  // KI Assistent (27.09.2026): ganze Sätze und Fragen bekommen oben die Zeile „Frag unseren Assistenten“. Klick oder Enter löst das Ereignis vp:assistent aus
  // (snippets/vp-assistent.liquid öffnet den Chat mit der Frage). Nur wenn der Assistent im Theme eingeschaltet ist (window.VpAssistent.aktiv).
  var FRAGE_RE = /^(ich suche|ich brauche|wir suchen|wir brauchen|was|welche[rsmn]?|wie|wo|gibt es|habt ihr|könnt ihr|kannst du|hast du|suche)\b/i;
  function istFrage(q) { var t = String(q || '').trim(); return !!t && (t.indexOf('?') > -1 || t.split(/\s+/).length > 5 || FRAGE_RE.test(t)); }
  function frageZeile(q) {
    return '<a class="vp-hsearch__item vp-hsearch__ask" role="option" href="#" data-vp-assistent data-q="' + esc(q) + '"><span class="vp-hsearch__askicon" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M12 3c5 0 9 3.4 9 7.6s-4 7.6-9 7.6c-.9 0-1.8-.1-2.6-.3L5 20l1.1-3.6C4.2 15 3 12.9 3 10.6 3 6.4 7 3 12 3z"/></svg></span>'
      + '<span class="vp-hsearch__text"><span class="vp-hsearch__title">Frag unseren Assistenten</span><span class="vp-hsearch__meta">„' + esc(String(q).slice(0, 90)) + '“</span></span></a>';
  }

  var EXAMPLES = [
    'Rote Trinkflasche', 'Weihnachtsgeschenke unter 10 €', 'Hoodie aus Biobaumwolle', 'Blaue Tasse mit Logo',
    'Lunchbox mit Bambusdeckel', 'Adventskalender unter 5 €', 'Schwarzer Rucksack', 'Give Aways für die Messe',
    'Grüne Thermosflasche', 'Welcome Kit für neue Mitarbeiter', 'Socken im eigenen Design', 'Notizbuch mit FSC Papier'
  ];

  var MAX_PRODUCTS = 8, MAX_COLLECTIONS = 4, MAX_PAGES = 3;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function euro(n) { return n.toFixed(2).replace('.', ','); }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function mitVariante(u, vid) { return /[?&]variant=/.test(u) ? u.replace(/([?&]variant=)\d+/, '$1' + vid) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vid; } // Shopify hängt bei Artikelnummer-Treffern selbst variant= an

  class VpHeaderSearch extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.form = this.querySelector('form');
      this.input = this.querySelector('.vp-hsearch__input');
      this.panel = this.querySelector('.vp-hsearch__panel');
      this.ghost = this.querySelector('.vp-hsearch__ghost');
      this.ghostText = this.querySelector('.vp-hsearch__ghost-text');
      this.suggestUrl = this.dataset.suggestUrl || '/search/suggest.json';
      this.searchUrl = this.dataset.searchUrl || '/search';
      this.collectionsUrl = this.dataset.collectionsUrl || '/collections';
      this.woerterUrl = this.dataset.woerterUrl || '';
      this.kiUrl = this.dataset.kiUrl || ''; // KI Suche (13.10.2026): Worker /api/suche, Bedeutungsvektoren je Produkt (src/suche/ki-suche.js)
      // Bio Pille (28.09.2026): nur für Treffer mit Kontrollstellencode (Feld b aus snippets/vp-smart-search-json.liquid). Der Treffer ist selbst ein Link,
      // deshalb öffnet die Pille das Biozertifikat über data-vp-bio-link im neuen Tab (gleicher Handler wie snippets/vp-pill.liquid)
      this.bioSiegel = this.dataset.bioSiegel || ''; this.bioPdf = this.dataset.bioPdf || '';
      if (!window.vpBioLink) {
        window.vpBioLink = 1;
        var bioOeffnen = function (e) { var t = e.target && e.target.closest && e.target.closest('[data-vp-bio-link]'); if (!t || (e.type === 'keydown' && e.key !== 'Enter')) return; e.preventDefault(); e.stopPropagation(); window.open(t.getAttribute('data-vp-bio-link'), '_blank', 'noopener'); };
        document.addEventListener('click', bioOeffnen, true); document.addEventListener('keydown', bioOeffnen, true);
      }
      this.cache = new Map();
      this.seq = 0;
      this.activeIndex = -1;
      this.current = null;
      this.focusPlaceholder = this.input.getAttribute('data-focus-placeholder') || '';
      this.mqDesktop = window.matchMedia('(min-width: 1024px)');
      this.closeBtn = this.querySelector('.vp-hsearch__close');
      this._home = document.createComment('vp-hsearch');
      this.parentNode.insertBefore(this._home, this);

      /* Mobil und Tablet: das Suchsymbol des Themes öffnet diese Suche als Vollbild statt der Shopify Suche */
      document.addEventListener('click', (e) => {
        if (this.isDesktop()) return;
        var link = e.target.closest && e.target.closest('.show-search-link');
        if (!link || this.contains(link)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.openSheet();
      }, true);
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.closeSheet());
      window.addEventListener('popstate', () => { if (this.isSheet()) { this._pushed = false; this.closeSheet(true); } });
      window.addEventListener('vp:assistent', () => { if (this.isSheet()) this.closeSheet(); });
      var onMq = () => {
        if (this.isDesktop()) { if (this.isSheet()) this.closeSheet(); this.startGhost(); }
        else this.stopGhost();
      };
      if (this.mqDesktop.addEventListener) this.mqDesktop.addEventListener('change', onMq); else if (this.mqDesktop.addListener) this.mqDesktop.addListener(onMq);

      this.input.addEventListener('focus', () => {
        this.woerter();
        this.classList.add('vp-hsearch--focus');
        this.stopGhost();
        this.input.setAttribute('placeholder', this.focusPlaceholder);
        if (!this.input.value.trim()) this.renderIdle(); else if (this.panel.innerHTML.trim()) this.open();
      });
      this.input.addEventListener('blur', () => {
        this.classList.remove('vp-hsearch--focus');
        if (!this.input.value.trim()) setTimeout(() => { if (document.activeElement !== this.input && !this.input.value.trim()) this.startGhost(); }, 1200);
      });
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      document.addEventListener('click', (e) => { if (!e.target.isConnected || this.contains(e.target)) return; this.close(); });
      this.panel.addEventListener('click', (e) => {
        var more = e.target.closest('[data-more]');
        if (more) { e.preventDefault(); e.stopPropagation(); this.showMore(more); return; }
        var ex = e.target.closest('[data-example]');
        if (ex) { e.preventDefault(); this.input.value = ex.getAttribute('data-example'); this.input.focus(); this.onInput(true); }
      });
      this.form.addEventListener('submit', async (e) => {
        e.preventDefault();
        var q = this.input.value.trim();
        if (!q) { this.input.focus(); return; }
        await this.woerter();
        var it = P.parse(q);
        if (it.sku) { var treffer = await this.skuTreffer(it); if (treffer.length === 1) { window.location.href = this.produktUrl(treffer[0]); return; } } // Artikelnummer eindeutig → direkt zum Produkt
        window.location.href = this.allUrl(it).url;
      });
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseGhost = true; else this.pauseGhost = false; });

      this.startGhost();
    }

    isDesktop() { return !this.mqDesktop || this.mqDesktop.matches; }

    /* Suchwörterbuch einmalig nachladen (assets/vp-suche-woerter.js), höchstens 1,5 s warten, sonst greift die eingebaute Liste */
    woerter() {
      if (window.VpSucheWoerter || !this.woerterUrl) return Promise.resolve();
      if (!this._woerter) this._woerter = new Promise((res) => { var sc = document.createElement('script'); sc.src = this.woerterUrl; sc.async = true; sc.onload = sc.onerror = () => res(); document.head.appendChild(sc); });
      return Promise.race([this._woerter, sleep(1500)]);
    }

    /* Artikelnummer: Produkte, deren Variante genau diese Nummer trägt (Feld s aus snippets/vp-smart-search-json.liquid: „SKU:VariantenID“, Leerzeichen getrennt) */
    skuPasst(p, it) {
      var n = it.sku.n, ls = String(p.s || '').split(' ');
      for (var i = 0; i < ls.length; i++) { var kv = ls[i].split(':'), k = (kv[0] || '').toUpperCase().replace(/[\s-]/g, ''); if (k === 'VP' + n) return { sku: kv[0], vid: kv[1] }; }
      return null;
    }
    async skuTreffer(it) {
      var listen = await Promise.all(it.sku.formen.map((f) => this.fetchSection(this.searchSectionUrl(f, it, false).toString())));
      var seen = {}, out = [];
      listen.forEach((l) => (l || []).forEach((p) => { var m = this.skuPasst(p, it); var key = (p.u || '').split('?')[0]; if (m && !seen[key]) { seen[key] = 1; out.push({ p: p, sku: m }); } }));
      return out;
    }
    kiSuche(q, it) {
      if (!this.kiUrl || q.length < 3) return Promise.resolve(null);
      var kq = q.replace(/(unter|bis zu|bis|max\.?|maximal|höchstens|weniger als)\s*\d+([.,]\d+)?\s*(€|euro|eur)?/ig, ' ').replace(/\d+([.,]\d+)?\s*(€|euro|eur)\b/ig, ' ').replace(/\s+/g, ' ').trim();
      if (kq.length < 2) return Promise.resolve(null);
      var u = new URL(this.kiUrl); u.searchParams.set('q', kq); u.searchParams.set('n', '20'); if (it.price) u.searchParams.set('max_preis', String(it.price));
      return Promise.race([this.fetchJson(u.toString()), sleep(1500).then(function () { return null; })]);
    }
    produktUrl(x) { return x.sku && x.sku.vid ? mitVariante(x.p.u, x.sku.vid) : x.p.u; }
    isSheet() { return this.classList.contains('vp-hsearch--sheet'); }

    /* ---------- Vollbild unter 1024 px ---------- */
    openSheet() {
      if (this.isSheet()) { this.input.focus(); return; }
      this.stopGhost();
      document.body.appendChild(this);
      this.classList.add('vp-hsearch--sheet');
      document.documentElement.classList.add('vp-hsearch-lock');
      this.input.setAttribute('placeholder', this.focusPlaceholder);
      try { history.pushState({ vpSearch: 1 }, ''); this._pushed = true; } catch (e) { this._pushed = false; }
      this.input.focus();
      if (!this.input.value.trim()) this.renderIdle(); else this.open();
    }
    closeSheet(fromPop) {
      if (!this.isSheet()) return;
      this.classList.remove('vp-hsearch--sheet');
      document.documentElement.classList.remove('vp-hsearch-lock');
      this.close();
      this.input.blur();
      if (this._home && this._home.parentNode) this._home.parentNode.insertBefore(this, this._home.nextSibling);
      if (!fromPop && this._pushed) { this._pushed = false; try { history.back(); } catch (e) {} }
    }

    /* ---------- Beispiel, das sich selbst tippt ---------- */
    startGhost() {
      if (this.ghostRunning || this.input.value.trim() || !this.isDesktop()) return;
      this.ghostRunning = true;
      this.classList.add('vp-hsearch--ghost');
      this.input.setAttribute('placeholder', '');
      this.ghostRun = (this.ghostRun || 0) + 1;
      this.ghostLoop(this.ghostRun);
    }
    stopGhost() {
      this.ghostRunning = false;
      this.ghostRun = (this.ghostRun || 0) + 1;
      this.classList.remove('vp-hsearch--ghost');
      this.ghostText.textContent = '';
      this.ghostText.classList.remove('is-typing', 'is-rest');
    }
    async ghostLoop(run) {
      var idx = this.ghostIndex || 0;
      var alive = () => this.ghostRunning && this.ghostRun === run;
      while (alive()) {
        var text = EXAMPLES[idx % EXAMPLES.length];
        this.currentExample = text;
        var started = Date.now();
        if (reduceMotion) {
          this.ghostText.textContent = text;
          this.ghostText.classList.add('is-rest');
        } else {
          this.ghostText.textContent = '';
          this.ghostText.classList.remove('is-rest', 'is-typing');
          this.ghostText.style.setProperty('--vs-sweep', Math.max(900, text.length * 62) + 'ms');
          void this.ghostText.offsetWidth;
          this.ghostText.classList.add('is-typing');
          for (var i = 1; i <= text.length; i++) {
            if (!alive()) return;
            while (this.pauseGhost && alive()) await sleep(400);
            this.ghostText.textContent = text.slice(0, i);
            await sleep(42 + Math.random() * 38 + (text[i - 1] === ' ' ? 60 : 0));
          }
          await sleep(1100);
          if (!alive()) return;
          this.ghostText.classList.add('is-rest');
          this.ghostText.classList.remove('is-typing');
        }
        var rest = 10000 - (Date.now() - started);
        while (rest > 0 && alive()) { await sleep(Math.min(rest, 500)); rest -= 500; while (this.pauseGhost && alive()) await sleep(500); }
        if (!alive()) return;
        if (!reduceMotion) {
          this.ghostText.classList.remove('is-rest');
          var cur = this.ghostText.textContent;
          for (var j = cur.length - 1; j >= 0; j--) {
            if (!alive()) return;
            this.ghostText.textContent = cur.slice(0, j);
            await sleep(16);
          }
          await sleep(350);
        }
        idx++;
        this.ghostIndex = idx;
      }
    }

    /* ---------- Panel ---------- */
    open() { this.classList.add('vp-hsearch--open'); this.input.setAttribute('aria-expanded', 'true'); }
    close() { this.classList.remove('vp-hsearch--open'); this.input.setAttribute('aria-expanded', 'false'); this.activeIndex = -1; }

    renderIdle() {
      var picks = EXAMPLES.slice(0, 6);
      var html = '<div class="vp-hsearch__group"><div class="vp-hsearch__label">Probier mal</div><div class="vp-hsearch__chips">'
        + picks.map(function (x) { return '<a href="#" class="vp-hsearch__chip" role="option" data-example="' + esc(x) + '">' + esc(x) + '</a>'; }).join('')
        + '</div><p class="vp-hsearch__hint">Beschreib einfach, was du brauchst. Farbe, Anlass und Budget lassen sich kombinieren, zum Beispiel „blaue Tasse unter 5 €“. Unsere Artikelnummern wie VP-90476 findest du hier auch.</p></div>';
      this.panel.innerHTML = html;
      this.activeIndex = -1;
      this.open();
    }

    onInput(immediate) {
      var q = this.input.value.trim();
      clearTimeout(this.timer);
      if (q.length < 2) { if (!q && document.activeElement === this.input) this.renderIdle(); else { this.panel.innerHTML = ''; this.close(); } return; }
      this.timer = setTimeout(() => this.run(q), immediate ? 0 : 260);
    }

    fetchJson(url) {
      if (this.cache.has(url)) return this.cache.get(url);
      var pr = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      this.cache.set(url, pr);
      return pr;
    }
    fetchSection(url) {
      if (this.cache.has(url)) return this.cache.get(url);
      var pr = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return [];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('script[data-vp-smart]');
          if (!node) return [];
          try { return (JSON.parse(node.textContent).products || []); } catch (e) { return []; }
        })
        .catch(function () { return []; });
      this.cache.set(url, pr);
      return pr;
    }

    sourceCollection(it) {
      if (it.category) return { h: it.category.h, label: it.category.label };
      if (it.brand) return { h: it.brand.h, label: it.brand.label };
      if (it.occasion) {
        var h = it.occasion.h;
        if (it.price && it.occasion.prices) {
          for (var i = 0; i < it.occasion.prices.length; i++) if (it.price <= it.occasion.prices[i][0]) { h = it.occasion.prices[i][1]; break; }
        }
        return { h: h, label: it.occasion.label };
      }
      if (it.gift || it.audience) {
        if (it.price) {
          var steps = [[5, 'geschenke-unter-5'], [10, 'geschenke-unter-10'], [15, 'geschenke-unter-15'], [30, 'geschenke-unter-30']];
          for (var k = 0; k < steps.length; k++) if (it.price <= steps[k][0]) return { h: steps[k][1], label: 'Geschenke unter ' + steps[k][0] + ' €' };
        }
        return { h: 'geschenksets', label: 'Geschenksets' };
      }
      return null;
    }

    filterParams(it, forUser) {
      var ps = [];
      it.colors.forEach(function (c) {
        ps.push(['filter.v.m.vpk.f_farbe', c.g]);
        var vals = forUser ? [OPTION_VALUES[c.g] ? OPTION_VALUES[c.g][0] : c.g] : (OPTION_VALUES[c.g] || [c.g]);
        vals.forEach(function (v) { ps.push(['filter.v.option.farbe', v]); });
      });
      if (it.price) ps.push(['filter.v.price.lte', String(it.price)]);
      return ps;
    }

    collectionUrl(h, it, withFilters, forUser) {
      var u = new URL(this.collectionsUrl.replace(/\/$/, '') + '/' + h, window.location.origin);
      if (!forUser) u.searchParams.set('section_id', 'vp-smart-search');
      u.searchParams.set('sort_by', it.cheap ? 'price-ascending' : 'best-selling');
      if (withFilters) this.filterParams(it, forUser).forEach(function (p) { u.searchParams.append(p[0], p[1]); });
      return u;
    }
    searchSectionUrl(q, it, withFilters) {
      var u = new URL(this.searchUrl, window.location.origin);
      u.searchParams.set('q', q);
      u.searchParams.set('type', 'product');
      u.searchParams.set('options[prefix]', 'last');
      u.searchParams.set('section_id', 'vp-smart-search');
      if (withFilters) this.filterParams(it, false).forEach(function (p) { u.searchParams.append(p[0], p[1]); });
      return u;
    }

    allUrl(it) {
      var src = this.sourceCollection(it);
      var suffix = '';
      if (it.colors.length) suffix += ' in ' + it.colors.map(function (c) { return c.g; }).join(' oder ');
      if (it.price) suffix += ' bis ' + String(it.price).replace('.', ',') + ' €';
      var eindeutig = !it.terms.length || (it.terms.length === 1 && ((it.category && it.category.oberbegriff) || (it.brand && !it.category)));
      if (src && eindeutig) { // 13.10.2026: nur bei eindeutigem Begriff direkt in die Sammlung („tassen“), sonst Suchergebnisse („müslischale“, „blaue tasse mit henkel“)
        var u = this.collectionUrl(src.h, it, true, true);
        return { url: u.pathname + u.search, label: 'Alle ' + src.label + suffix + ' ansehen' };
      }
      var q = it.searchQ || it.original;
      if (it.colors.length) q += ' ' + (COLOR_WORD[it.colors[0].g] || it.colors[0].g.toLowerCase());
      var s = new URL(this.searchUrl, window.location.origin);
      s.searchParams.set('q', q.trim());
      s.searchParams.set('options[prefix]', 'last');
      if (it.price) s.searchParams.set('filter.v.price.lte', String(it.price));
      return { url: s.pathname + s.search, label: 'Alle Treffer für „' + it.original + '“ ansehen' };
    }

    async run(q) {
      var seq = ++this.seq;
      await this.woerter();
      if (seq !== this.seq) return;
      var it = P.parse(q);
      if (it.sku) return this.runSku(it, seq);
      this.current = it;
      this.panel.classList.add('is-loading');
      if (!this.panel.innerHTML.trim() || this.panel.querySelector('[data-example]')) {
        this.panel.innerHTML = '<div class="vp-hsearch__loading"><span></span><span></span><span></span></div>';
        this.open();
      }

      var src = this.sourceCollection(it);
      var jobs = [];
      var wantsColor = it.colors.length > 0 || !!it.price;
      if (src) {
        jobs.push({ kind: 'coll', p: this.fetchSection(this.collectionUrl(src.h, it, wantsColor, false).toString()) });
        if (wantsColor) jobs.push({ kind: 'coll', p: this.fetchSection(this.collectionUrl(src.h, it, false, false).toString()) });
      }
      if (it.searchQ) {
        jobs.push({ kind: 'search', p: this.fetchSection(this.searchSectionUrl(it.searchQ, it, false).toString()) });
        if (it.colors.length) {
          var cw = COLOR_WORD[it.colors[0].g] || it.colors[0].g.toLowerCase();
          jobs.push({ kind: 'search', p: this.fetchSection(this.searchSectionUrl(it.searchQ + ' ' + cw, it, false).toString()) });
        }
      }
      if (!src && !it.searchQ) jobs.push({ kind: 'search', p: this.fetchSection(this.searchSectionUrl(q, it, false).toString()) });

      var predQ = it.searchQ || (src ? src.label : q);
      var pu = new URL(this.suggestUrl, window.location.origin);
      pu.searchParams.set('q', predQ);
      pu.searchParams.set('resources[type]', 'collection,page');
      pu.searchParams.set('resources[limit]', '6');
      pu.searchParams.set('resources[limit_scope]', 'each');
      var predP = this.fetchJson(pu.toString());

      var kiP = this.kiSuche(q, it);
      var results = await Promise.all(jobs.map(function (j) { return j.p; }));
      var pred = await predP;
      var ki = await kiP;
      if (seq !== this.seq) return;

      var searchFirst = !src || it.terms.length >= 2 || !!(it.category && !it.category.oberbegriff); // Kompositum („Müslischale“): erst die echten Treffer, dann die Kategorie
      var collLists = [], searchLists = [];
      jobs.forEach(function (j, i) { (j.kind === 'coll' ? collLists : searchLists).push(results[i] || []); });
      // KI Treffer (Bedeutung statt Wortgleichheit): Liste im Format der Section Daten, Kategorie-Vorschlag, wenn das Wörterbuch keinen Oberbegriff kennt
      var kiList = ((ki && ki.produkte) || []).filter(function (x, i, a) { return x.score >= (a[0].score - 0.12); }).map(function (x) { return { t: x.t, u: x.u, i: x.i, p: x.p, a: true, z: '', m: '', b: '', v: [], s: '', ki: x.score }; });
      var kiArt = ki && ki.arten && ki.arten[0];
      if (kiArt && kiArt.seite && kiArt.anteil >= 0.5 && (!it.category || (!it.category.oberbegriff && kiArt.anteil >= 0.7))) { it.category = { h: kiArt.seite, label: kiArt.label, token: '', exact: false, ki: true }; if (!src) src = { h: kiArt.seite, label: kiArt.label }; }
      it._ki = kiList.length ? {} : null; kiList.forEach(function (x) { it._ki[x.u.split('?')[0]] = 1; });
      // Reciprocal Rank Fusion: KI Gewicht 1, Wortsuche 0,8, Kategorie 0,5 (Oberbegriff 0,9)
      var gew = []; if (kiList.length) gew.push([kiList, 1]);
      searchLists.forEach(function (l) { gew.push([l, 0.8]); });
      collLists.forEach(function (l) { gew.push([l, (searchFirst || kiList.length) ? 0.5 : 0.9]); });
      var punkte = {}, objekt = {};
      gew.forEach(function (g) { g[0].forEach(function (p, i) { var key = (p.u || '').split('?')[0]; if (!key) return; punkte[key] = (punkte[key] || 0) + g[1] / (20 + i); if (!objekt[key] || (objekt[key].ki && !p.ki)) objekt[key] = p; }); });
      var list = Object.keys(punkte).sort(function (a, b) { return punkte[b] - punkte[a]; }).map(function (k) { return objekt[k]; });

      var products = this.rank(list, it);
      // Einzelprodukt erkannt (14.10.2026, Nicole): Titel enthält alle Suchwörter, die Suche besteht nicht nur aus Gattungswörtern oder einer Marke
      it._erk = this.produktErkannt(it, products);
      if (it._erk && it.category && !it.category.oberbegriff) it.category = null; // bei Produktnamen nur echte Oberbegriffe als Kategorie zeigen („Hamar Cap“ → Caps, „Snug“ nicht → Socken)
      this.render(it, products, pred, src);
    }

    produktErkannt(it, products) {
      if (!products.length || it.sku) return null;
      var toks = (it.terms || []).filter(function (t) { return t.length >= 2 && !/^\d+([.,]\d+)?$/.test(t); });
      if (!toks.length || toks.join('').length < 4) return null;
      var generisch = toks.every(function (t, i) { var h = P.lookup(t, i === 0); return !!(h && (h.oberbegriff || h.brand)); });
      if (generisch) return null;
      for (var i = 0; i < Math.min(products.length, 8); i++) {
        var w = P.norm(products[i].p.t).split(' ');
        if (toks.every(function (t) { return w.some(function (x) { return x.indexOf(t) === 0 || (t.length >= 5 && x.indexOf(t) > -1); }); })) return products[i];
      }
      return null;
    }

    async aehnlicheLaden(x) {
      var box = this.panel.querySelector('[data-vp-aehnlich]'); var id = x && x.p && x.p.id;
      if (!box || !id || !this.kiUrl) { if (box) box.remove(); return; }
      var d = await Promise.race([this.fetchJson(this.kiUrl.replace(/\/$/, '') + '/aehnlich?id=' + encodeURIComponent(String(id).split('/').pop()) + '&n=6'), sleep(2000).then(function () { return null; })]);
      if (!box.isConnected) return;
      var self = this; var schon = {}; this.panel.querySelectorAll('.vp-hsearch__item').forEach(function (a) { schon[(a.getAttribute('href') || '').split('?')[0]] = 1; });
      var l = ((d && d.produkte) || []).filter(function (p) { return !schon[p.u]; }).slice(0, 4);
      if (!l.length) { box.remove(); return; }
      box.innerHTML = '<div class="vp-hsearch__label">Ähnliche Produkte</div>' + l.map(function (p) { return self.productRow({ p: { t: p.t, u: p.u, i: p.i, p: p.p }, hit: null, certs: [], price: (p.p || 0) / 100 }); }).join('');
    }

    async runSku(it, seq) {
      this.panel.classList.add('is-loading');
      if (!this.panel.innerHTML.trim() || this.panel.querySelector('[data-example]')) { this.panel.innerHTML = '<div class="vp-hsearch__loading"><span></span><span></span><span></span></div>'; this.open(); }
      var treffer = await this.skuTreffer(it);
      if (seq !== this.seq) return;
      var html = '<div class="vp-hsearch__understood"><svg class="vp-hsearch__spark" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l1.9 6.1 6.1 1.9-6.1 1.9L12 18.5l-1.9-6.1L4 10.5l6.1-1.9z"/></svg><span class="vp-hsearch__understood-label">Erkannt</span><span class="vp-hsearch__tag">Artikelnummer</span></div>';
      if (treffer.length) {
        html += '<div class="vp-hsearch__group"><div class="vp-hsearch__label">Artikel</div>';
        treffer.forEach((x) => { html += this.productRow({ p: x.p, hit: null, certs: [], price: (x.p.p || 0) / 100, sku: x.sku }); });
        html += '</div>';
      } else {
        html += '<div class="vp-hsearch__empty">Zur Artikelnummer VP-' + esc(it.sku.n) + ' haben wir im Shop keinen aktiven Artikel. Prüf die Nummer oder schreib uns, wir helfen dir weiter.</div>';
        html += '<a class="vp-hsearch__all" role="option" href="/pages/kontakt?anliegen=angebot">Anfrage an das Team</a>';
      }
      this.moreQueue = [];
      this.panel.classList.remove('is-loading');
      this.panel.innerHTML = html;
      this.activeIndex = -1;
      this.open();
    }

    rank(list, it) {
      var extras = it.terms.filter(function (t) { return !it.category || t !== it.category.token; }).map(function (t) { return t.slice(0, 6); });
      var titelWoerter = it.terms.filter(function (t) { return t.length >= 4; }).map(function (t) { return P.formen(t).filter(function (f) { return f.length >= 4; }); }); // Suchwort steht im Titel → nach oben („Müslischale“)
      var scored = [];
      list.forEach(function (p, idx) {
        var price = (p.p || 0) / 100;
        if (it.price && price > it.price + 0.001) return;
        var score = 0, hit = null, certHits = [];
        if (it.colors.length) {
          var vs = p.v || [];
          for (var i = 0; i < vs.length && !hit; i++) {
            var v = vs[i];
            for (var c = 0; c < it.colors.length; c++) {
              if (v.f ? v.f === it.colors[c].g : P.colorOfText(v.t, it.colors[c])) { hit = { v: v, c: it.colors[c] }; break; }
            }
          }
          if (!hit && vs.length <= 1 && !(vs[0] && vs[0].f)) {
            for (var c2 = 0; c2 < it.colors.length; c2++) if (P.colorOfText(p.t, it.colors[c2])) { hit = { v: vs[0] || null, c: it.colors[c2] }; break; }
          }
          if (hit) score += 4;
        }
        it.certs.forEach(function (ce) {
          var zs = (p.z || '').split(','), ms = (p.m || '').split(',');
          var ok = (ce.z || []).some(function (z) { return zs.indexOf(z) > -1; }) || (ce.m || []).some(function (m) { return ms.indexOf(m) > -1; });
          if (ok) { score += 3; certHits.push(ce.label); }
        });
        var nt = P.norm(p.t);
        extras.forEach(function (e) { if (e.length > 2 && nt.indexOf(e) > -1) score += 1; });
        if (!it._ki || it._ki[(p.u || '').split('?')[0]]) titelWoerter.forEach(function (fs) { if (fs.some(function (f) { return nt.indexOf(f) > -1; })) score += 2; }); // mit KI nur für Treffer, die auch die KI passend findet („rund“ hebt keine runden Tassen)
        if (p.a === false) score -= 0.5;
        scored.push({ p: p, score: score, hit: hit, certs: certHits, idx: idx, price: price });
      });
      scored.sort(function (a, b) { return (b.score - a.score) || (a.idx - b.idx); });
      return scored;
    }

    rankTitles(q, items) {
      var words = P.norm(q).split(' ').filter(function (w) { return w.length > 1; });
      return items.map(function (x, i) {
        var t = P.norm(x.title);
        var s = words.length && words.every(function (w) { return t.indexOf(w) > -1; }) ? 2 : (words.some(function (w) { return t.indexOf(w) > -1; }) ? 1 : 0);
        return { x: x, s: s, i: i };
      }).sort(function (a, b) { return (b.s - a.s) || (a.i - b.i); }).map(function (o) { return o.x; });
    }

    swatch(c) {
      var cls = 'vp-hsearch__dot';
      if (c.g === 'Transparent') cls += ' vp-hsearch__dot--clear';
      if (c.g === 'Mehrfarbig') cls += ' vp-hsearch__dot--multi';
      if (c.g === 'Holz') cls += ' vp-hsearch__dot--wood';
      return '<span class="' + cls + '"' + (c.hex ? ' style="background:' + c.hex + '"' : '') + '></span>';
    }

    render(it, products, pred, src) {
      var self = this;
      var res = (pred && pred.resources && pred.resources.results) || {};
      var html = '';
      if (window.VpAssistent && window.VpAssistent.aktiv && istFrage(it.original)) html += frageZeile(it.original);

      var chips = [];
      it.colors.forEach(function (c) { chips.push('<span class="vp-hsearch__tag">' + self.swatch(c) + esc(c.g) + '</span>'); });
      if (it.category) chips.push('<a class="vp-hsearch__tag vp-hsearch__tag--link" href="' + esc(self.collectionsUrl.replace(/\/$/, '') + '/' + it.category.h) + '">' + esc(it.category.label) + '</a>');
      if (it.brand) chips.push('<a class="vp-hsearch__tag vp-hsearch__tag--link" href="' + esc(self.collectionsUrl.replace(/\/$/, '') + '/' + it.brand.h) + '">Marke ' + esc(it.brand.label) + '</a>');
      if (it.occasion) chips.push('<a class="vp-hsearch__tag vp-hsearch__tag--link" href="' + esc(self.collectionsUrl.replace(/\/$/, '') + '/' + (src && !it.category ? src.h : it.occasion.h)) + '">' + esc(it.occasion.label) + '</a>');
      if ((it.gift || it.audience) && !it.occasion && !it.category && src) chips.push('<a class="vp-hsearch__tag vp-hsearch__tag--link" href="' + esc(self.collectionsUrl.replace(/\/$/, '') + '/' + src.h) + '">' + esc(src.label) + '</a>');
      if (it.price) chips.push('<span class="vp-hsearch__tag">bis ' + esc(String(it.price).replace('.', ',')) + ' €</span>');
      if (it.cheap) chips.push('<span class="vp-hsearch__tag">Günstige zuerst</span>');
      it.certs.forEach(function (ce) { chips.push('<span class="vp-hsearch__tag">' + esc(ce.label) + '</span>'); });
      if (chips.length) {
        html += '<div class="vp-hsearch__understood"><svg class="vp-hsearch__spark" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l1.9 6.1 6.1 1.9-6.1 1.9L12 18.5l-1.9-6.1L4 10.5l6.1-1.9z"/></svg><span class="vp-hsearch__understood-label">Erkannt</span>' + chips.join('') + '</div>';
      }

      if (it._erk) {
        html += '<div class="vp-hsearch__group"><div class="vp-hsearch__label">Gesuchtes Produkt</div>' + self.productRow(it._erk) + '</div>';
        html += '<div class="vp-hsearch__group" data-vp-aehnlich><div class="vp-hsearch__label">Ähnliche Produkte</div><div class="vp-hsearch__loading"><span></span><span></span><span></span></div></div>';
        products = products.filter(function (x) { return x !== it._erk; });
      }
      if (products.length) {
        var anyColorHit = products.some(function (x) { return x.hit; });
        html += '<div class="vp-hsearch__group"><div class="vp-hsearch__label">' + (it._erk ? 'Weitere Treffer' : 'Produkte') + '</div>';
        if (it.colors.length && !anyColorHit) html += '<p class="vp-hsearch__note">In ' + esc(it.colors.map(function (c) { return c.g; }).join(' oder ')) + ' ist in den ersten Treffern nichts dabei. Das hier kommt am nächsten.</p>';
        products.slice(0, MAX_PRODUCTS).forEach(function (x) { html += self.productRow(x); });
        this.moreQueue = products.slice(MAX_PRODUCTS);
        if (this.moreQueue.length) html += this.moreButton();
        html += '</div>';
      } else {
        this.moreQueue = [];
      }

      var cols = [];
      if (src) cols.push({ title: src.label, url: self.collectionsUrl.replace(/\/$/, '') + '/' + src.h });
      this.rankTitles(it.searchQ || it.original, res.collections || []).forEach(function (c) { cols.push({ title: c.title, url: c.url }); });
      var seenC = {}; cols = cols.filter(function (c) { var k = c.url.split('?')[0]; if (seenC[k]) return false; seenC[k] = true; return true; }).slice(0, MAX_COLLECTIONS);
      if (cols.length) {
        html += '<div class="vp-hsearch__group"><div class="vp-hsearch__label">Kategorien</div><div class="vp-hsearch__chips">'
          + cols.map(function (c) { return '<a class="vp-hsearch__chip" role="option" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div></div>';
      }

      var pgs = [];
      if (it.occasion && it.occasion.page) pgs.push({ title: it.occasion.label === 'Onboarding' ? 'Mitarbeiter Geschenkboxen' : 'Weihnachtsgeschenke für Mitarbeiter und Kunden', url: it.occasion.page });
      else if (it.audience) pgs.push({ title: 'Geschenke für Mitarbeiter mit Logo', url: '/pages/geschenke-mitarbeiter' });
      (res.pages || []).forEach(function (pg) { pgs.push({ title: pg.title, url: pg.url }); });
      var seenP = {}; pgs = pgs.filter(function (p) { var k = p.url.split('?')[0]; if (seenP[k]) return false; seenP[k] = true; return true; }).slice(0, MAX_PAGES);
      if (pgs.length) {
        html += '<div class="vp-hsearch__group"><div class="vp-hsearch__label">Seiten</div><div class="vp-hsearch__chips">'
          + pgs.map(function (p) { return '<a class="vp-hsearch__chip" role="option" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'; }).join('') + '</div></div>';
      }

      var all = this.allUrl(it);
      if (!products.length && !cols.length && !pgs.length) {
        html += '<div class="vp-hsearch__empty">Dazu haben wir im Shop gerade nichts Passendes. Schreib uns, was du vorhast, wir finden es in unserem Lieferantensortiment.</div>';
        html += '<a class="vp-hsearch__all" role="option" href="/pages/kontakt?anliegen=angebot">Anfrage an das Team</a>';
      } else {
        html += '<a class="vp-hsearch__all" role="option" href="' + esc(all.url) + '">' + esc(all.label) + '</a>';
      }

      this.panel.classList.remove('is-loading');
      this.panel.innerHTML = html;
      this.activeIndex = -1;
      this.open();
      if (it._erk) this.aehnlicheLaden(it._erk);
    }

    productRow(x) {
      var p = x.p;
      var img = (x.hit && x.hit.v && x.hit.v.i) || p.i;
      var url = p.u;
      if (x.hit && x.hit.v && x.hit.v.id) url += (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + x.hit.v.id;
      if (x.sku && x.sku.vid) url = mitVariante(url, x.sku.vid);
      var meta = [];
      if (x.sku) meta.push('<span class="vp-hsearch__match">Art.-Nr. ' + esc(x.sku.sku) + '</span>');
      if (x.hit) meta.push('<span class="vp-hsearch__match">' + this.swatch(x.hit.c) + 'in ' + esc(this.variantColorLabel(x.hit)) + '</span>');
      var bio = p.b ? this.bioPill(p.b) : '';
      x.certs.forEach(function (l) { if (bio && l === 'Bio zertifiziert') { meta.push(bio); bio = ''; return; } meta.push('<span class="vp-hsearch__match">' + esc(l) + '</span>'); });
      return '<a class="vp-hsearch__item" role="option" href="' + esc(url) + '">'
        + (img ? '<img class="vp-hsearch__thumb" src="' + esc(img) + '" alt="" loading="lazy" width="46" height="46">' : '<span class="vp-hsearch__thumb"></span>')
        + '<span class="vp-hsearch__text"><span class="vp-hsearch__title">' + esc(p.t) + '</span>'
        + '<span class="vp-hsearch__meta">' + meta.join('') + '<span class="vp-hsearch__price">ab ' + euro(x.price) + ' €</span></span></span></a>';
    }

    bioPill(code) {
      if (!this.bioPdf) return '';
      return '<span class="vp-pill vp-pill--cert vp-pill--sm vp-pill--bio" role="link" tabindex="0" data-vp-bio-link="' + esc(this.bioPdf) + '" title="Öko Kontrollstelle ' + esc(code) + ', unser Biozertifikat (PDF)">'
        + '<span class="vp-pill__siegel">' + (this.bioSiegel ? '<img src="' + esc(this.bioSiegel) + '" width="27" height="18" alt="Bio Siegel DE-ÖKO-070" loading="lazy">' : '') + '</span><span>EU Bio</span></span>';
    }

    moreButton() {
      var n = this.moreQueue.length;
      return '<button type="button" class="vp-hsearch__more" role="option" data-more>Mehr anzeigen <span>(' + n + (n === 1 ? ' weiteres' : ' weitere') + ')</span></button>';
    }

    showMore(btn) {
      var next = this.moreQueue.splice(0, MAX_PRODUCTS);
      if (!next.length) { btn.remove(); return; }
      var html = next.map((x) => this.productRow(x)).join('');
      btn.insertAdjacentHTML('beforebegin', html);
      var firstNew = btn.parentNode.querySelectorAll('.vp-hsearch__item')[btn.parentNode.querySelectorAll('.vp-hsearch__item').length - next.length];
      if (this.moreQueue.length) btn.outerHTML = this.moreButton(); else btn.remove();
      this.activeIndex = -1;
      if (firstNew) firstNew.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
      this.input.focus({ preventScroll: true });
    }

    variantColorLabel(hit) {
      if (!hit.v || !hit.v.t || hit.v.t === 'Default Title') return hit.c.g;
      var parts = hit.v.t.split(' / ');
      for (var i = 0; i < parts.length; i++) if (P.colorOfText(parts[i], hit.c)) return parts[i];
      return hit.c.g;
    }

    onKey(e) {
      if (e.key === 'Escape') { if (this.isSheet()) this.closeSheet(); else { this.close(); this.input.blur(); } return; }
      if (!this.classList.contains('vp-hsearch--open')) return;
      var items = Array.from(this.panel.querySelectorAll('[role="option"]'));
      if (!items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        items.forEach(function (el) { el.classList.remove('vp-hsearch__item--active'); });
        this.activeIndex = e.key === 'ArrowDown' ? Math.min(this.activeIndex + 1, items.length - 1) : Math.max(this.activeIndex - 1, 0);
        items[this.activeIndex].classList.add('vp-hsearch__item--active');
        items[this.activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.activeIndex >= 0) {
        e.preventDefault();
        items[this.activeIndex].click();
      }
    }
  }

  window.customElements.define('vp-header-search', VpHeaderSearch);
})();
